import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { User } from '@core/auth/interfaces/user';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserService } from '../services/user.service';

/**
 * Resolver function for user data.
 *
 * Resolves user data from the route parameter 'userId'.
 * Returns null for 'add' route or when user is not found.
 *
 * @param route - The activated route snapshot containing route parameters
 * @returns Observable of User data or null
 */
export const userResolverFn = (
	route: ActivatedRouteSnapshot
): Observable<User> => {
	const userSvc = inject(UserService);
	const userId = route.paramMap.get('userId');

	return userId && userId !== 'add'
		? userSvc.find(userId).pipe(catchError(() => of(null)))
		: of(null);
};